export const ROOT_PARENT_CACHE_KEY = 'root';

export const getParentCacheKey = (parentId) => (
  parentId ? String(parentId) : ROOT_PARENT_CACHE_KEY
);

export default getParentCacheKey;
